import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import { withTranslation } from "react-i18next";
import tooltipImg from "../../../../assets/images/info_black-tooltip.svg";

const RoleCheckbox = ({
  t,
  id,
  checked,
  onChange,
  label,
  tooltipText,
  disabled = false,
  className = "",
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const tooltipId = `Tooltip${id}`;

  return (
    <div className={`account-checkbox d-flex ${className}`}>
      <div className="ch-checkbox">
        <label className={id === "Admin" ? "mt-1" : ""}>
          <input
            type="checkbox"
            name={id.toLowerCase()}
            onChange={onChange}
            checked={checked}
            disabled={disabled}
          />
          <span>
            {label}{" "}
            <img
              className="ml-2 cursor-pointer"
              onClick={() => setTooltipOpen(true)}
              id={tooltipId}
              src={tooltipImg}
              alt="icon"
            />
          </span>
        </label>
      </div>

      <Tooltip
        className="new-item-card-catalogue-tooltip"
        isOpen={tooltipOpen}
        placement="top"
        target={tooltipId}
        toggle={() => setTooltipOpen(!tooltipOpen)}
      >
        {tooltipText}
      </Tooltip>
    </div>
  );
};

export default withTranslation()(RoleCheckbox);
